export interface OrderInvoiceModel {
    id?: number;
    type: OrderInvoiceModel.TypeEnum;
    number: string;
}
export namespace OrderInvoiceModel {
    export type TypeEnum = 'invoice' | 'extra_invoice';
    export const TypeEnum = {
        Invoice: 'invoice' as TypeEnum,
        ExtraInvoice: 'extra_invoice' as TypeEnum
    };
}
